"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _features = require("../../Shared/store/features");

var HasFeature = function HasFeature(_ref) {
  var featureKey = _ref.featureKey,
      children = _ref.children,
      fallback = _ref.fallback;
  var flags = Array.isArray(featureKey) ? featureKey.join(',') : featureKey;
  var hasFeatureFlags = (0, _react.useMemo)(function () {
    return _features.Features.selectors.hasFeatureFlags(flags);
  }, [flags]);
  var isEnabled = (0, _reactRedux.useSelector)(hasFeatureFlags);
  return isEnabled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fallback);
};

HasFeature.propTypes = {
  featureKey: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired]).isRequired,
  children: _propTypes.default.node,
  fallback: _propTypes.default.node
};
HasFeature.defaultProps = {
  children: undefined,
  fallback: undefined
};
var _default = HasFeature;
exports.default = _default;